import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
// @ts-ignore
import { Echo, Channel, SocketIoPrivateChannel, SocketIoPresenceChannel, SocketIoChannel } from "laravel-echo-ionic";
import { HttpClient } from '@angular/common/http';
import { StorageService } from '../services/storage.service';

@Injectable({
    providedIn: 'root'
})
export class EchoService {

    channels : string[] = [];
    echo?: Echo;
    private initializing?: Promise<void>;
    private generation = 0;
    token: any;

    constructor(private storage: StorageService, private http: HttpClient) {
    }

    init(){
        if (this.echo) return Promise.resolve();
        if (this.initializing) return this.initializing;
        const generation = this.generation;
        this.initializing = this.storage.get('user').then(v => {
            if (generation !== this.generation) return;
            if(v || this.token){
                this.echo = new Echo({
                    broadcaster: 'socket.io',
                    host : environment.ws,
                    auth: {
                        headers: {
                            Accept: 'application/json',
                            Authorization: v ? (v.token_type + ' ' + v.access_token) : (this.token.token_type + ' ' + this.token.access_token),
                            // Middleware: 'APP'
                        },
                    },
                });

                // this.echo.connector.socket.on('connect', () => {
                //     console.log('CONNECTED');
                //     this.http.post(environment.url + 'online', {status: true}).subscribe()
                // });

                // this.echo.connector.socket.on('reconnecting', function () {
                //     //console.log('CONNECTING');
                // });

                // this.echo.connector.socket.on('disconnect', () => {
                //     console.log('DISCONNECTED');
                //     this.http.post(environment.url + 'online', {status: false}).subscribe()
                // });
            }
        }).finally(() => {
            if (generation === this.generation) this.initializing = undefined;
        });
        return this.initializing;
    }

    addPrivate(name: string) : Observable<SocketIoPrivateChannel> {
        return new Observable((handle) => {
            const generation = this.generation;
            if(this.channels.indexOf(name) === -1){
                if (this.echo){
                    this.channels.push(name);
                    handle.next(this.echo.private(name));
                } else {
                    this.init().then(() => {
                        if (generation !== this.generation || !this.echo) return;
                        this.channels.push(name);
                        handle.next(this.echo.private(name));
                    });
                }
            }else{
                handle.error('listener já registrado');
            }
        });
    };

    addPresence(name: string) : Observable<SocketIoPresenceChannel> {
        return new Observable((handle) => {
            const generation = this.generation;
            if(this.channels.indexOf(name) === -1){
                if (this.echo){
                    this.channels.push(name);
                    handle.next(this.echo.join(name));
                } else {
                    this.init().then(() => {
                        if (generation !== this.generation || !this.echo) return;
                        this.channels.push(name);
                        handle.next(this.echo.join(name));
                    });
                }
            }else{
                handle.error('listener já registrado');
            }
        });
    };

    addPublic(name: string) : Observable<SocketIoChannel> {
        return new Observable((handle) => {
            const generation = this.generation;
            if(this.channels.indexOf(name) === -1){
                if (this.echo){
                    this.channels.push(name);
                    handle.next(this.echo.channel(name));
                } else {
                    this.init().then(() => {
                        if (generation !== this.generation || !this.echo) return;
                        this.channels.push(name);
                        handle.next(this.echo.channel(name));
                    });
                }
            }else{
                handle.error('listener já registrado');
            }
        });
    };

    remListener(name: string) {
        this.echo?.leave(name);
        const index = this.channels.indexOf(name);
        if (index >= 0) this.channels.splice(index, 1);
    }

    remAll(){
        this.generation++;
        this.initializing = undefined;
        [...this.channels].forEach((c) => {
            this.remListener(c);
        });
        this.echo?.disconnect();
        this.echo = undefined;
    }

    getSocketId() {
        return this.echo ? this.echo.socketId() : null;
    }
}
